import React from 'react'

import CssBaseline from '@mui/material/CssBaseline'
import Container from '@mui/material/Container'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'

import SubTitleSubLayout from 'layouts/Landing/sublayouts/SubHeader'

import DeliveryAddress from 'components/posting_notice_request/DeliveryAddress'
import GeneralInformation from 'components/posting_notice_request/GeneralInformation'
import PostingNotices from 'components/posting_notice_request/PostingNotices'
import usePostingNoticeRequestContext from 'hooks/posting_notice_request/usePostingNoticeRequestContext'
import { PostingNoticeRequestProvider } from 'contexts/posting_notice_request/PostingNoticeRequestContext'
import CoverLetter from 'components/posting_notice_request/CoverLetter'
import ShippingPackaging from 'components/posting_notice_request/ShippingPackaging'
import Review from 'components/posting_notice_request/Review'

function PostingNoticeRequest() {
  const { stage, setStage, setShippingAddress } =
    usePostingNoticeRequestContext()

  const steps = [
    'Set Recipient',
    'General Information',
    'Posting Notices',
    'Cover Letter',
    'Shipping/Packaging',
    'Review',
  ]

  const getTitle = () => {
    return 'Posting Notices Request'
  }

  const handleNext = (values) => {
    if (stage === 0) {
      setStage(1)
      setShippingAddress(values)
    }
  }

  return (
    <SubTitleSubLayout title={getTitle()} disableMargin>
      <CssBaseline />
      <Stepper activeStep={stage} alternativeLabel sx={{ my: 8 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel
              sx={{
                '&.Mui-completed': {
                  color: 'success.main',
                },
                '& .MuiStepIcon-root': {
                  '&.Mui-completed': {
                    color: 'success.main',
                  },
                  '&.Mui-active': {
                    color: 'primary.main',
                  },
                },
              }}
            >
              {label}
            </StepLabel>
          </Step>
        ))}
      </Stepper>
      <Container sx={{ pb: 16 }}>
        {stage === 0 && <DeliveryAddress onNext={handleNext} />}
        {stage === 1 && <GeneralInformation />}
        {stage === 2 && <PostingNotices />}
        {stage === 3 && <CoverLetter />}
        {stage === 4 && <ShippingPackaging />}
        {stage === 5 && <Review />}
      </Container>
    </SubTitleSubLayout>
  )
}

function PostingNoticeRequestWrapper() {
  return (
    <PostingNoticeRequestProvider>
      <PostingNoticeRequest />
    </PostingNoticeRequestProvider>
  )
}

export default PostingNoticeRequestWrapper
